'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function GuaranteeSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  return (
    <section
      ref={ref}
      className="py-12 sm:py-16 md:py-24 lg:py-32 bg-gradient-to-br from-gray-50 to-white"
    >
      <div className="max-w-4xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          {/* Badge */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 bg-black rounded-full mb-4 sm:mb-6"
          >
            <i className="ri-shield-check-line text-3xl sm:text-4xl md:text-5xl text-white" />
          </motion.div>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="font-serif text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-black mb-3 sm:mb-4"
          >
            30-Day Money Back Guarantee
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="text-black/70 text-sm sm:text-base md:text-lg lg:text-xl mb-6 sm:mb-8 max-w-2xl mx-auto leading-relaxed"
          >
            We're so confident you'll love this lighter, we'll give you 30 full days to test it.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="bg-white rounded-lg p-6 sm:p-8 shadow-lg mb-6 sm:mb-8 text-left"
          >
            <p className="text-black/80 text-xs sm:text-sm md:text-base lg:text-lg mb-4 sm:mb-6 leading-relaxed">
              If it doesn't work perfectly, doesn't meet your expectations, or you're unsatisfied for <strong>ANY reason</strong>, send it back for a full refund.
            </p>

            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-close-circle-line text-xl sm:text-2xl text-black flex-shrink-0 mt-0.5" />
                <span className="text-black/70 text-xs sm:text-sm md:text-base">
                  <strong>No questions asked.</strong> No hassles. No fine print.
                </span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-truck-line text-xl sm:text-2xl text-black flex-shrink-0 mt-0.5" />
                <span className="text-black/70 text-xs sm:text-sm md:text-base">
                  <strong>We handle return shipping.</strong> You risk absolutely nothing.
                </span>
              </div>
            </div>
          </motion.div>

          <motion.p
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.6 }}
            className="text-black/60 text-xs sm:text-sm md:text-base italic"
          >
            Why can we offer this? Because less than 2% of customers return it.<br />
            <strong>The quality speaks for itself.</strong>
          </motion.p>
        </motion.div>
      </div>
    </section>
  );
}
